import { databaseRef } from 'config'

import { action } from '../../dispatchAction'
import { USER_ACTION_TYPES } from '../types'

export const deleteChild = (id: string) => async (dispatch, getState) => {
  dispatch(action(USER_ACTION_TYPES.delete_child_begins))

  try {
    const {
      auth: { uid },
      data
    } = getState().user

    const childrenRef = databaseRef
      .child('users')
      .child(uid)
      .child('children')

    const res = (
      await childrenRef
        .orderByValue()
        .equalTo(id)
        .once('value')
    ).val()

    const key = res && Object.keys(res)[0]

    if (key) {
      childrenRef.child(key).remove()

      // update deletion counter
      const userRef = databaseRef
        .child('users')
        .child(uid)
        .child('deletion_counter')

      const counter = (await userRef.once('value')).val()
      const deletionCounter = counter ? counter + 1 : 1
      userRef.set(deletionCounter)
      data.deletion_counter = deletionCounter
    }

    data.children = Object.keys(data.children)
      .filter(k => data.children[k] !== id)
      .reduce((acc, k) => ({ ...acc, [k]: data.children[k] }), {})

    dispatch(action(USER_ACTION_TYPES.update_user_success, { userData: data }))
  } catch (error) {
    console.error(error)
    dispatch(action(USER_ACTION_TYPES.delete_child_error, { message: error }))
  }
}



// WEBPACK FOOTER //
// ./src/store/user/actions/deleteChild.action.ts